module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_6000.0905c664.png";